export default __webpack_public_path__ + "static/media/tired.5cce35bd.svg";